import { render, staticRenderFns } from "./ChangeTierModal.vue?vue&type=template&id=70313ab1&"
import script from "./ChangeTierModal.vue?vue&type=script&lang=js&"
export * from "./ChangeTierModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports